import React, { useState, useMemo } from "react";
import Select from "react-select";
import { countries } from "countries-list";
import emailjs from "@emailjs/browser";
import Swal from 'sweetalert2';
import "../styles/contact.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


export default function Contact() {
  const [loading, setLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      el && el.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const countryOptions = useMemo(() => {
    return Object.entries(countries).map(([code, country]) => ({
      value: country.name,
      label: `${country.emoji || ""} ${country.name}`.trim(),
    }));
  }, []);

  // Premium Select Styling
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      padding: "8px",
      borderRadius: "12px",
      border: state.isFocused ? "2px solid #C68642" : "2px solid transparent",
      backgroundColor: "#ffffff",
      boxShadow: "none",
      "&:hover": { borderColor: "#C68642" }
    }),
    placeholder: (base) => ({ ...base, color: "#999" }),
    menu: (base) => ({ ...base, borderRadius: "12px", overflow: "hidden", zIndex: 5 })
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    const templateParams = {
      from_name: e.target.user_name.value,
      company_name: e.target.company.value,
      reply_to: e.target.user_email.value,
      country: selectedCountry ? selectedCountry.value : "Not Specified",
      volume: e.target.volume.value,
      message: e.target.message.value,
    };

    emailjs.send(
      'service_d0h0uyd', 
      'template_ulq150b', 
      templateParams, 
      '-I-JVlLJFuBe6leX-'
    )
    .then(() => {
      setIsSent(true);
      window.scrollTo({ top: 400, behavior: 'smooth' });
    })
    .catch((err) => {
      setLoading(false);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Submission failed. Please try again.' });
    })
    .finally(() => setLoading(false));
  };

  return (
    <>
      <section className="contact-hero">
        <div className="container">
          <div className="contact-hero-content">
            <span className="section-label light">Global Partnerships</span>
            <h1 className="contact-title">Premium Export Assistance</h1>
            <p className="contact-subtitle">
              Partner with Aditya Exports Ventures for a sophisticated, ethical, and seamless 
              supply chain experience from India's finest plantations.
            </p>
          </div>
        </div>
      </section>

      {/* <section className="contact-benefits">
        <div className="container">
          <div className="benefits-grid">
            <div className="benefit-card">
              <span className="benefit-icon">🌍</span>
              <h3>Global Expertise</h3>
              <p>Navigating international trade laws and logistics to ensure your beans arrive fresh.</p>
            </div>
            <div className="benefit-card">
              <span className="benefit-icon">📦</span>
              <h3>Custom Fulfillment</h3>
              <p>From boutique micro-lots to commercial bulk shipments tailored to your needs.</p>
            </div>
            <div className="benefit-card">
              <span className="benefit-icon">🤝</span>
              <h3>Trade Support</h3>
              <p>Direct access to our export coordinators for professional communication.</p>
            </div>
          </div>
        </div>
      </section> */}

      <section className="contact-main" id="contact-form">
        <div className="container contact-grid">
          <div className="contact-info-card">
            <h3>Export Office</h3>
            <p className="info-text">Directly connecting the coffee plantations of India to roasters and distributors worldwide.</p>
              <div className="info-block">
                <h4>Registered Address</h4>
                <p>
                  Flat No BF-03, SR No 26A/02, Simple Park,<br />
                  Sasane Nagar, Hadapsar, Pune,<br />
                  Maharashtra – 411028
                </p>
              </div>
            <div className="info-block"><h4> GSTIN</h4><p>27JGEPS3900L1ZY</p></div>
            <div className="info-block"><h4>Direct Email</h4><p>info@adityaexportsventures.com</p></div>
            <div className="info-block trade-phone">
                    <h4>Trade Phone</h4>
                    <p>+91 95527 94179</p> 
                    <p>+91 83085 99393</p>
                    <p className="trade-hours">Available 24/7 for Trade Inquiries</p>
              </div>
            <div className="export-checklist">
              <h4>Expert Guidance On:</h4>
              <ul className="list-unstyled">
                <li>✔ Certificate of Origin & ICO Docs</li>
                <li>✔ Phytosanitary & SGS Safety</li>
                <li>✔ Bulk & Specialty Pricing</li>
                <li>✔ Private Label Solutions</li>
              </ul>
            </div>
          </div>

          <div className="contact-form-wrapper">
            {!isSent ? (
              <form className="contact-form" onSubmit={sendEmail}>
                <h3 className="form-title">Send Your Requirements</h3>
                <div className="form-group">
                  <input type="text" name="user_name" placeholder="Full Name" required />
                </div>
                <div className="form-group">
                  <input type="email" name="user_email" placeholder="Email" required />
                </div>
                <div className="form-group">
                  <input type="text" name="company" placeholder="Company Name" />
                </div>
                <div className="form-group">
                  <Select
                    options={countryOptions}
                    value={selectedCountry}
                    onChange={setSelectedCountry}
                    placeholder="Select Country of Import"
                    styles={customSelectStyles}
                    required
                  />
                </div>
                <div className="form-group" style={{ marginTop: "1rem" }}>
                  <input type="number" name="volume" placeholder="Order Volume (KG or Tons)" required />
                </div>
                <div className="form-group">
                  <textarea name="message" rows="6" placeholder="Tell us about your project..." required></textarea>
                </div>
                <button type="submit" className="btn-coffee-submit w-100" disabled={loading}>
                  {loading ? "Processing..." : "Initialize Trade Request"}
                </button>
              </form>
            ) : (
              <div className="luxury-success-card">
                <div className="luxury-icon-wrapper">
                   <div className="luxury-check-ring"></div>
                   <img src="/logo512.png" alt="Logo" className="luxury-success-logo" />
                </div>
                <h3 className="luxury-success-title">Thank You</h3>
                <p className="luxury-success-subtitle">Inquiry Received with Priority</p>
                <div className="success-divider"></div>
                <p className="success-message">
                  An export coordinator will reach out to you within 24 business hours.
                </p>
                <button className="btn-luxury-return" onClick={() => setIsSent(false)}>
                  Submit Another Inquiry
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="contact-cta">
        <div className="container">
          <div className="cta-inner">
            <h2 className="section-title light">Ready to Source the Finest?</h2>
            <p>Join a network of global partners who trust Aditya Exports Ventures.</p>
            <a href="/contact#contact-form" className="btn-outline-cream">Request Sample Kit</a>
          </div>
        </div>
      </section>
    </>
  );
}